// Foundations
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';

// rxjs
import { finalize } from 'rxjs/operators';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CognitoService } from 'src/app/services/cognito.service';
import { RegisterService } from 'src/app/services/register.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { MyProfileService } from '../../../services/my-profile.service';

// Components
import { ConfirmDialogComponent } from '../../_share/confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

const PHONE_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.scss'],
})
export class BasicInfoComponent implements OnInit {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public myProfileService: MyProfileService,
    private registerService: RegisterService,
    private cognitoService: CognitoService,
    private _analytics: AnalyticsService,
    private loadingIndicatorService: LoadingIndicatorService
  ) {
    this.form = this.fb.group({
      email: [
        '',
        { validators: [Validators.required, Validators.pattern(EMAIL_REGEX)] },
      ],
      passwordForm: [],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      phone: this.fb.group({
        id: null,
        phoneNumber: [
          '',
          [Validators.required, Validators.pattern(PHONE_REGEX)],
        ],
        phoneType: this.myProfileService.phoneTypeList[0],
      }),
    });
  }

  ngOnInit(): void {
    this._analytics.logScreen('regPage');

    this.form.get('email').valueChanges.subscribe((res) => {
      this.form.patchValue(
        { email: this.form.get('email').value.toLowerCase() },
        { emitEvent: false }
      );
    });
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f(): any {
    return this.form.controls;
  }

  navigateToSignIn() {
    this._analytics.logLinkTap('reg_signIn');
  }

  onRegister(): void {
    this._analytics.logButtonTap('reg_registerNow');

    const {
      email,
      passwordForm: { password },
      firstName,
      lastName,
      phone,
    } = this.form.value;

    this.loadingIndicatorService.show();
    this.cognitoService
      .signUp({ username: email, password })
      .pipe(finalize(() => this.loadingIndicatorService.hide()))
      .subscribe((status) => {
        if (status.result === 'SUCCESS') {
          this.registerService.updateRegisterFormData({
            email,
            password,
            firstName,
            lastName,
            phone,
          });
          this.form.markAsPristine();
          this.router.navigate(['./code'], { relativeTo: this.route });
        } else {
          if (status.result === 'UsernameExistsException') {
            // use to autofill email in login page
            this.registerService.existingEmail = email;
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              panelClass: 'general-dialog',
              data: {
                title: 'Email Found',
                content: `Great! We found your email in our system. Please proceed to login.`,
                okText: 'OK',
                okFn: () => {
                  dialogRef.close();
                  this.router.navigate(['/sign-in']);
                },
              },
              autoFocus: false,
              disableClose: true,
            });
          } else {
            this.snackBar.open(status.message, '', { duration: 2000 });
          }
        }
      });
  }

  link2TermsOfUse() {
    this._analytics.logButtonTap('reg_termOfUse');
    //
    window.location.href = 'https://www.campbowwow.com/terms-of-use/';
  }
}
